import { Duration } from 'luxon';
import { BaseDataGridRequest } from "../base-data-grid.request";

export interface GetJobsGridDataRequest extends BaseDataGridRequest {
  id?: string,
  jobNumber?: string,
  jobName?: string,
  jobTemplate?:string,
  startAddress?: string,
  endAddress?: string,
  startTime?: Duration,
  endTime?: Duration,
  startLatitude?: number,
  startLongitude?: number,
  endLatitude?: number,
  endLongitude?: number,
  duration?: number,
  capacityType1?: number,
  planId?: string;
  capacityType2?: number,
  createdAt?: Duration,
  vehicleType?: string
}
